/**
 * The `config` module: the data model (attributes, options, forms) and a
 * community's layers, maps and option enablement. Server half:
 * app/resources/plugins/arc/config/.
 */

const seg = encodeURIComponent;

export default {
  // The module's pages load on the first route that needs them (core/js/modules.js);
  // the shell warms them in idle time after sign-in. Boot carries the shell only.
  load: () => Promise.all([import('../components/config.js')]),
  name: 'config',

  nav: {
    area: 'Config',
    items: [
      { route: 's/:site/config',  label: 'Community setup', sitePerm: 'CommunityManage' },
      { route: 'config/attributes', label: 'Attributes', perm: 'Admin' },
      { route: 'config/forms',      label: 'Forms',      perm: 'Admin' },
    ],
  },

  routes: {
    '/s/:site/config':    'arc-site-config',
    '/config/attributes': 'arc-attributes',
    '/config/forms':      'arc-forms',
    '/config/forms/:formId': 'arc-form-page',
  },

  resources: (api) => ({
    model: {
      attributes: (params) => api.get('/attributes', params),
      attribute: (id) => api.get(`/attributes/${seg(id)}`),
      createAttribute: (body) => api.post('/attributes', body),
      updateAttribute: (id, body) => api.put(`/attributes/${seg(id)}`, body),
      deleteAttribute: (id) => api.del(`/attributes/${seg(id)}`),
      createOption: (attributeId, body) => api.post(`/attributes/${seg(attributeId)}/options`, body),
      updateOption: (attributeId, id, body) => api.put(`/attributes/${seg(attributeId)}/options/${seg(id)}`, body),
      deleteOption: (attributeId, id) => api.del(`/attributes/${seg(attributeId)}/options/${seg(id)}`),
      forms: () => api.get('/forms'),
      form: (id) => api.get(`/forms/${seg(id)}`),
      createForm: (body) => api.post('/forms', body),
      updateForm: (id, body) => api.put(`/forms/${seg(id)}`, body),
      deleteForm: (id) => api.del(`/forms/${seg(id)}`),
      setFields: (id, body) => api.put(`/forms/${seg(id)}/fields`, body),
      fileCategories: () => api.get('/file-categories'),
      // Per community.
      siteOptions: (siteId) => api.get(`/sites/${seg(siteId)}/attribute-options`),
      setSiteOptions: (siteId, body) => api.put(`/sites/${seg(siteId)}/attribute-options`, body),
      layers: (siteId) => api.get(`/sites/${seg(siteId)}/layers`),
      createLayer: (siteId, body) => api.post(`/sites/${seg(siteId)}/layers`, body),
      updateLayer: (siteId, id, body) => api.put(`/sites/${seg(siteId)}/layers/${seg(id)}`, body),
      deleteLayer: (siteId, id, confirm) => api.del(`/sites/${seg(siteId)}/layers/${seg(id)}`, { confirm }),
      // The parcel importer: a GeoJSON file with dry_run=1 (the report) or apply=1 (+ apply_new / apply_geometry / apply_properties).
      importLayer: (siteId, layerId, file, fields) => api.upload(`/sites/${seg(siteId)}/layers/${seg(layerId)}/import`, file, fields),
    },
  }),
};
